(() => {
  const ROOT_SELECTOR = "[data-itazuke-custom-order]";
  const DATA_SELECTOR = "[data-itazuke-custom-order-data]";
  const CARE_VARIANT_ID = 52560569729304;

  const parseData = (root) => {
    const node = root.querySelector(DATA_SELECTOR);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error("ITAZUKE Custom Order data parse failed", error);
      return null;
    }
  };

  const getPlants = (data) => {
    if (Array.isArray(data.plants)) return data.plants;
    return data.plant ? [data.plant] : [];
  };

  const findPlant = (data, plantId) =>
    getPlants(data).find((plant) => plant.id === plantId);

  const findCombination = (data, deckId, plantId) =>
    data.combinations.find(
      (combination) =>
        combination.deck_id === deckId && combination.plant_id === plantId
    );

  const isPlantUnavailable = (plant) => {
    if (!plant) return true;
    return plant.sold === true || plant.available === false;
  };

  const isUnavailable = (deck, plant, combination) => {
    if (!deck || !plant || !combination) return true;

    return (
      deck.sold === true ||
      deck.available === false ||
      plant.sold === true ||
      plant.available === false ||
      combination.sold === true ||
      combination.available === false
    );
  };

  const normalizeImageUrl = (url) => {
    if (!url) return "";
    return url.startsWith("//") ? `${window.location.protocol}${url}` : url;
  };

  const pickDeckIdForPlant = (data, plantId, preferredDeckId) => {
    const preferredDeck = data.decks.find((deck) => deck.id === preferredDeckId);
    const plant = findPlant(data, plantId);

    if (preferredDeck && plant) {
      const preferredCombination = findCombination(data, preferredDeck.id, plantId);
      if (!isUnavailable(preferredDeck, plant, preferredCombination)) {
        return preferredDeck.id;
      }
    }

    const firstAvailableDeck = data.decks.find((deck) => {
      const combination = findCombination(data, deck.id, plantId);
      return !isUnavailable(deck, plant, combination);
    });

    return firstAvailableDeck ? firstAvailableDeck.id : preferredDeckId || data.decks[0]?.id;
  };

  const pickInitialSelection = (data) => {
    const plants = getPlants(data);

    for (const plant of plants) {
      const deck = data.decks.find((item) => {
        const combination = findCombination(data, item.id, plant.id);
        return !isUnavailable(item, plant, combination);
      });

      if (deck) {
        return {
          selectedDeckId: deck.id,
          selectedPlantId: plant.id
        };
      }
    }

    return {
      selectedDeckId: data.decks[0]?.id,
      selectedPlantId: plants[0]?.id
    };
  };

  const setHidden = (element, hidden) => {
    if (element) element.hidden = hidden;
  };

  const setText = (element, value) => {
    if (element) element.textContent = value || "";
  };

  const ensureCareStyles = () => {
    if (document.getElementById("pluqe-custom-order-care-styles")) return;

    const style = document.createElement("style");
    style.id = "pluqe-custom-order-care-styles";
    style.textContent = `
      .itazuke-custom-order__care-option { margin: 1.6rem 0; padding: 1.4rem 1.5rem; border: 1px solid rgba(var(--color-foreground), .18); border-radius: .6rem; }
      .itazuke-custom-order__care-label { display: flex; align-items: flex-start; gap: 1rem; cursor: pointer; }
      .itazuke-custom-order__care-checkbox { width: 1.8rem; height: 1.8rem; margin: .15rem 0 0; flex: 0 0 auto; accent-color: rgb(var(--color-foreground)); }
      .itazuke-custom-order__care-copy { display: flex; flex-direction: column; gap: .3rem; }
      .itazuke-custom-order__care-title { font-weight: 600; line-height: 1.45; }
      .itazuke-custom-order__care-sub { font-size: 1.2rem; line-height: 1.5; opacity: .72; }
      .itazuke-custom-order__care-details { margin-top: 1rem; font-size: 1.2rem; }
      .itazuke-custom-order__care-details summary { cursor: pointer; text-decoration: underline; text-underline-offset: .25rem; }
      .itazuke-custom-order__care-details-body { margin-top: .8rem; line-height: 1.65; }
      .itazuke-custom-order__care-details-body p { margin: 0 0 .8rem; }
      .itazuke-custom-order__care-details-body ul { margin: 0; padding-left: 1.8rem; }
      .itazuke-custom-order__care-details-body li + li { margin-top: .35rem; }
    `;
    document.head.appendChild(style);
  };

  const createCareOption = () => {
    const wrapper = document.createElement("div");
    wrapper.className = "itazuke-custom-order__care-option";
    wrapper.setAttribute("data-custom-order-care-option", "");
    wrapper.innerHTML = `
      <label class="itazuke-custom-order__care-label">
        <input type="checkbox" class="itazuke-custom-order__care-checkbox" data-custom-order-care-checkbox>
        <span class="itazuke-custom-order__care-copy">
          <span class="itazuke-custom-order__care-title">ITAZUKE CAREを追加する　＋¥3,300</span>
          <span class="itazuke-custom-order__care-sub">購入から1年間・1回の植物付け直しサポート</span>
        </span>
      </label>
      <details class="itazuke-custom-order__care-details">
        <summary>ITAZUKE CAREについて</summary>
        <div class="itazuke-custom-order__care-details-body">
          <p>購入後1年以内に植物が枯れたり、大きく弱ってしまった場合、まず写真で状態を確認します。必要に応じて植物の付け直しを行います。</p>
          <ul>
            <li>対象作品の購入日から1年間・1回限り</li>
            <li>状態によっては育て方をご案内する場合があります</li>
            <li>同じ植物をご用意できない場合は、ご相談のうえ別の植物へ変更する場合があります</li>
            <li>PLUQEへ作品を送る送料はお客様負担、対応後の返送料はPLUQE負担です</li>
          </ul>
        </div>
      </details>
    `;
    return wrapper;
  };

  const init = (root) => {
    if (root.dataset.itazukeCustomOrderReady === "true") return;

    const data = parseData(root);
    const plants = data ? getPlants(data) : [];

    if (
      !data ||
      !Array.isArray(data.decks) ||
      !Array.isArray(data.combinations) ||
      plants.length === 0
    ) {
      return;
    }

    root.dataset.itazukeCustomOrderReady = "true";
    ensureCareStyles();

    const deckButtons = Array.from(root.querySelectorAll("[data-deck-button]"));
    const plantButtons = Array.from(root.querySelectorAll("[data-plant-button]"));
    const previewImage = root.querySelector("[data-preview-image]");
    const previewPlaceholder = root.querySelector("[data-preview-placeholder]");
    const previewPlaceholderName = root.querySelector("[data-preview-placeholder-name]");
    const previewSoldNote = root.querySelector("[data-preview-sold-note]");
    const summarySoldNote = root.querySelector("[data-summary-sold-note]");
    const summaryDeck = root.querySelector("[data-summary-deck]");
    const summaryPlant = root.querySelector("[data-summary-plant]");
    const summaryPrice = root.querySelector("[data-summary-price]");
    const summaryList = root.querySelector(".itazuke-custom-order__summary-list");
    const summaryCareLink = root.querySelector("[data-summary-care-link]");
    const buyButton = root.querySelector("[data-buy-button]");
    const cartError = root.querySelector("[data-cart-error]");

    let careOption = root.querySelector("[data-custom-order-care-option]");
    if (!careOption && summaryList) {
      careOption = createCareOption();
      summaryList.insertAdjacentElement("afterend", careOption);
    }
    const careCheckbox = careOption?.querySelector("[data-custom-order-care-checkbox]");

    const initialSelection = pickInitialSelection(data);
    let previewRequestId = 0;

    const state = {
      selectedDeckId: initialSelection.selectedDeckId,
      selectedPlantId: initialSelection.selectedPlantId,
      isSubmitting: false
    };

    const getDeck = () => data.decks.find((deck) => deck.id === state.selectedDeckId);
    const getPlant = () => findPlant(data, state.selectedPlantId);
    const getCombination = () =>
      findCombination(data, state.selectedDeckId, state.selectedPlantId);

    const showPreviewError = () => {
      if (!previewImage || !previewPlaceholder) return;
      previewImage.removeAttribute("src");
      previewImage.alt = "";
      previewImage.hidden = true;
      previewPlaceholder.hidden = false;
      setText(previewPlaceholderName, "画像を読み込めませんでした");
    };

    const renderPreview = (combination) => {
      if (!previewImage || !previewPlaceholder) return;

      const requestId = ++previewRequestId;

      if (!combination?.preview_image) {
        previewImage.removeAttribute("src");
        previewImage.alt = "";
        previewImage.hidden = true;
        previewPlaceholder.hidden = false;
        setText(previewPlaceholderName, combination?.preview_file || "");
        return;
      }

      const nextSrc = combination.preview_image;
      const nextAlt = `${combination.deck_name} / ${combination.plant_name} preview`;
      const loader = new Image();

      loader.onload = () => {
        if (requestId !== previewRequestId) return;
        if (!(loader.complete && loader.naturalWidth > 0)) {
          showPreviewError();
          return;
        }
        previewImage.src = nextSrc;
        previewImage.alt = nextAlt;
        previewImage.hidden = false;
        previewPlaceholder.hidden = true;
      };

      loader.onerror = () => {
        if (requestId !== previewRequestId) return;
        showPreviewError();
      };

      loader.src = nextSrc;
    };

    const render = () => {
      const deck = getDeck();
      const plant = getPlant();
      const combination = getCombination();
      const unavailable = isUnavailable(deck, plant, combination);

      deckButtons.forEach((button) => {
        const deckId = button.dataset.deckId;
        const buttonDeck = data.decks.find((item) => item.id === deckId);
        const buttonCombination = findCombination(data, deckId, state.selectedPlantId);
        const buttonUnavailable = isUnavailable(buttonDeck, plant, buttonCombination);
        const isSelected = deckId === state.selectedDeckId;

        button.classList.toggle("is-selected", isSelected);
        button.classList.toggle("is-sold", buttonUnavailable);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        button.disabled = buttonUnavailable;
      });

      plantButtons.forEach((button) => {
        const plantId = button.dataset.plantId;
        const buttonPlant = findPlant(data, plantId);
        const buttonUnavailable = isPlantUnavailable(buttonPlant);
        const isSelected = plantId === state.selectedPlantId;

        button.classList.toggle("is-selected", isSelected);
        button.classList.toggle("is-sold", buttonUnavailable);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        button.disabled = buttonUnavailable;
      });

      renderPreview(combination);

      setText(summaryDeck, combination?.deck_name || deck?.name || "");
      setText(summaryPlant, combination?.plant_name || plant?.name || "");
      setText(summaryPrice, combination?.price_text || "");

      if (summaryCareLink) {
        if (plant?.care_url) {
          summaryCareLink.href = plant.care_url;
          summaryCareLink.hidden = false;
        } else {
          summaryCareLink.hidden = true;
        }
      }

      setHidden(previewSoldNote, !unavailable);
      setHidden(summarySoldNote, !unavailable);

      if (careCheckbox) {
        careCheckbox.disabled = unavailable || state.isSubmitting;
      }

      if (buyButton) {
        buyButton.disabled = unavailable || state.isSubmitting;
        buyButton.textContent = state.isSubmitting
          ? "追加中..."
          : unavailable
            ? "販売対象外です"
            : "この組み合わせで購入する";
      }
    };

    deckButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;
        state.selectedDeckId = button.dataset.deckId;

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();
      });
    });

    plantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;

        state.selectedPlantId = button.dataset.plantId;
        state.selectedDeckId = pickDeckIdForPlant(
          data,
          state.selectedPlantId,
          state.selectedDeckId
        );

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();
      });
    });

    if (buyButton) {
      buyButton.addEventListener("click", async () => {
        const deck = getDeck();
        const plant = getPlant();
        const combination = getCombination();

        if (isUnavailable(deck, plant, combination) || state.isSubmitting) return;

        state.isSubmitting = true;

        if (cartError) {
          cartError.textContent = "";
          cartError.hidden = true;
        }

        render();

        try {
          const mainItem = {
            id: combination.variant_id,
            quantity: 1,
            properties: {
              _itazuke_preview_image: normalizeImageUrl(combination.preview_image),
              _itazuke_preview_alt: `${combination.deck_name} / ${combination.plant_name}`
            }
          };

          const items = [mainItem];

          if (careCheckbox?.checked) {
            items.push({
              id: CARE_VARIANT_ID,
              quantity: 1,
              properties: {
                "_ITAZUKE CARE対象作品": `${combination.deck_name} / ${combination.plant_name}`
              }
            });
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.description || errorData.message || "カート追加に失敗しました。");
          }

          window.location.href = "/cart";
        } catch (error) {
          if (cartError) {
            cartError.textContent = error.message || "カート追加に失敗しました。時間をおいて再度お試しください。";
            cartError.hidden = false;
          }
        } finally {
          state.isSubmitting = false;
          render();
        }
      });
    }

    render();
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();